import http from "./http.js";
import moment from "moment";
moment.locale("uk");

async function getGlobalSettingsReportsCheck() {
  try {
    const response = await http.get("global-settings");
    return response.data.reportsCheck;
  } catch (err) {
    throw err;
  }
}

async function updateGlobalSettingsReportsCheck(reportsCheck) {
  try {
    await http.patch("global-settings/reports-check", {}, {
      params: {
        reportsCheck,
      },
    });
  } catch (err) {
    throw err;
  }
}

async function getReportsCheck() {
  try {
    const response = await http.get("reports-check");
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getAnalysisClientBalances() {
  try {
    const response = await http.get("analysis-client-balances");
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function updateAnalysisClientBalances(from) {
  try {
    const response = await http.post("update-client-balances", {
      from,
    });
    return response;
  } catch (err) {
    throw err;
  }
}


export {
  getGlobalSettingsReportsCheck,
  updateGlobalSettingsReportsCheck,
  getReportsCheck,
  getAnalysisClientBalances,
  updateAnalysisClientBalances,
};